module.exports = __webpack_public_path__ + "img/building_jiagou_2560.85da8f63.png";